import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {Select} from '@ngxs/store';
import {AppState} from '../../state/appState';
import {UserModel} from '../services/user/user.model';
import {map, take, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard implements CanActivate {
  @Select(AppState.currentUser$) currentUser: Observable<UserModel>;

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.currentUser.pipe(
      take(1),
      map(u => u != null),
      tap((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          console.log('user not logged in, redirecting to login');
          this.router.navigate(['/login']);
        }
      })
    );
  }

}
